<template>
	<div class="mt20 ovh ">
		<el-table :data="brandList" style="width: 100%" border>
      <el-table-column prop="brandName" label="品牌中文名称" min-width="100" align="center">
      </el-table-column>
      <el-table-column prop="brandEnname" label="品牌英文名称" min-width="100" align="center">
      </el-table-column>
      <el-table-column prop="categoryName" label="经营品类" align="center"  min-width="300">
          <template scope="scope">
              <p v-for="category in scope.row.supplierApplyBrandCategories">{{category.category.grandName}}-{{category.category.parentName}}-{{category.category.childrenName}}</p>
          </template>
      </el-table-column>
      <el-table-column prop="statusDesc" label="审核状态" align="center">
      </el-table-column>
      <el-table-column label="操作" width="200" align="center">

        <template scope="scope">
            <el-button @click="openDetail(scope.row.brandApplyId,0)" type="text" size="small">查看详情</el-button>
            <el-button v-if="hasSelBrandSAuth == 1 && scope.row.brandId==0" @click="openDetail(scope.row.brandApplyId,1)" type="text" size="small">选择品牌</el-button>
        </template>
      </el-table-column>
    </el-table>
	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
            return {
                statsName: ["未知状态", "未提交", "待采销初审", "初审驳回", "编辑合同中", "待供应商确认合同", "供应商驳回合同", "驳回合同", "待复审", "驳回资质信息", "待纸质合同保证金到位", "入驻成功"],
                isNoNext: false,				// 下一步 按钮状态
                hasSelBrandSAuth: 0,//选择品牌权限
                brandList: [],
                supplierApplyId:0
            };
		},
		methods: {
            initBrandList(supplierApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/findSupplierApplyBrands',
                    data: {
                        supplierApplyId: supplierApplyId
                    },
                    success: function(result) {
                        if (!result.code) {
                            that.brandList=result.data.list;
                        } else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            /**
             * 打开品牌详情页面
             * @param id
             */
            openDetail(id,hasSelBrand){
                window.open("/suppliers/index2/#/auditBrandDetail?brandApplyId=" + id+"&hasSelBrand="+hasSelBrand);
            },

			formatter (row) {
                var name = "未知状态";
                if(row.status>=0 && row.status<=this.statsName.length) {
                    name = this.statsName[row.status];
                }
                return name;
			}
		},
        mounted () {
            var supplierApplyId=this.$route.query.supplierApplyId;
            this.supplierApplyId = supplierApplyId;
            this.initBrandList(supplierApplyId);

        },
        created () {
            var _this = this;
            window.eventHub.$on('reloadBrandList', (data) => {
                _this.initBrandList(_this.supplierApplyId);
            })
        }
	}
</script>

<style type="text/css" lang="less" scoped>
	.min_height {
		min-height: 300px;
	}
</style>


// WEBPACK FOOTER //
// brandList.vue?57396df7